.ux-radio-button-field {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  position: relative;

  &__media-container {
    overflow: hidden;
    position: relative;
  }

  &--with-media {
    @include u-shadow();

    display: flex;
    flex-direction: column;

    img {
      display: block;
      min-width: 100%;
      transition: all $animationSpeed-normal $animationEasing-easeInOut;
    }
  }

  &--with-media:hover {
    .ux-radio-button-field__media-container img {
      transform: scale(1.03);
    }
  }

  &--with-media,
  &--as-box {
    .ux-radio-button-field__label-container {
      align-items: center;
      background-color: $color-white;
      display: flex;
      justify-content: space-between;
      min-height: 60px;
      padding: 30px;
    }
  }

  &--as-box {
    box-shadow: 0 7px 22px rgb(19 19 19 / 10%);
    width: 100%;
  }

  &__description-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: $color-white;
    border: 0;
    color: $color-black;
    cursor: pointer;
    display: block;
    padding: 0 10px;
    text-align: center;
    text-decoration: none;
    transform: translate(10px, 0);
  }

  &__border {
    border: 2px solid $color-green;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;
  }
}
